<app-auto-complete-dropdown
    *ngIf="callbackData && callbackData[0] && callbackData[0].arg"
    [data]="callbackData[0].arg[1]"
    [selectedValue]="callbackData[0].arg[0]"
    [appendToBody]="true"
    (selectedItemEvent)="selectedItem($event)"
>
</app-auto-complete-dropdown>
